import { App } from 'antd';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import SpinnerLoader from './libraries/SpinnerLoader';
import AntdProvider from './providers/antd.provider';
import ErrorProvider from './providers/error.provider';
import MessageProvider from './providers/message.provider';
import RouteProvider from './providers/route.provider';
import { persistor, store } from './stores';
import './styles/custom.scss';

function AppClient() {
  return (
    <Provider store={store}>
      <PersistGate loading={<SpinnerLoader bg={false} />} persistor={persistor}>
        <AntdProvider>
          <App>
            <MessageProvider>
              <ErrorProvider>
                <RouteProvider />
              </ErrorProvider>
            </MessageProvider>
          </App>
        </AntdProvider>
      </PersistGate>
    </Provider>
  );
}

export default AppClient;
